import { render, staticRenderFns } from "./registrationfees.vue?vue&type=template&id=c71bf690"
import script from "./registrationfees.vue?vue&type=script&lang=js"
export * from "./registrationfees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports